module.exports = __webpack_public_path__ + "assets/pin-default.29e4c3a3.svg";